import type { Resident } from '@lmc/ts-common'
import type { ReactElement } from 'react'
import * as React from 'react'
import { SignatureSection } from '../../../../../../../../components/generic'

type SignLaterModalProps = {
  onSubmitSign: ({ formState }: { formState: any }) => Promise<void>
  setShowSignatureModal: (show: boolean) => void
  showSignatureModal: boolean
  resident: Resident
  translate: (key: string, variable?: any) => string
}

export const SignNowModal = ({
  onSubmitSign,
  resident,
  translate,
  setShowSignatureModal,
  showSignatureModal
}: SignLaterModalProps): ReactElement => (
  <SignatureSection
    title={translate('consentToCare')}
    resident={resident}
    logs={[]}
    buttonLabel={translate('sign')}
    footerLabel={translate('signsConsentsToCare', {
      variable: resident?.preferredName || resident?.name?.first
    })}
    confirmText={translate('confirm', {
      variable: resident?.preferredName || resident?.name?.first
    })}
    isSubmitting={false}
    helpUrl="helpUrl"
    onSubmit={onSubmitSign as any}
    isModalOnly
    isModalVisible={showSignatureModal}
    onClose={() => setShowSignatureModal(false)}
  />
)

export default SignNowModal
